import { FileCheck2, Kanban, PencilLine, Users } from 'lucide-react'
import Card from '../../../../components/common/Card'
import DefaultTabs from '../../../../components/common/Tabs'
import { useCompany } from '../../../../context/CompanyContext'
import Business from './Business'
import Contacts from './Contacts/Contacts'
import Notes from './Notes'

export function CompanyTabs() {
    const { detail } = useCompany()
    if (!detail) return null

    //* Contadores
    const numContacts = detail.contacts.length
    const numNotes = detail.notes.length
    const numBusiness = detail.business.length
    const numAttachments = 0 //detail.attachments.length

    const tabsData = [
        {
            icon: <Users className='w-4 h-4' />,
            label: (
                <div className='flex items-start justify-center gap-1'>
                    <p>Contatos</p>
                    {numContacts > 0 && <p className='text-xs text-brand-400 font-bold'>{numContacts}</p>}
                </div>
            ),
            value: 'tab1',
            content: <Contacts />
        },
        {
            icon: <PencilLine className='w-4 h-4' />,
            label: (
                <div className='flex items-start justify-center gap-1'>
                    <p>Notas</p>
                    {numNotes > 0 && <p className='text-xs text-brand-400 font-bold'>{numNotes}</p>}
                </div>
            ),
            value: 'tab2',
            content: <Notes />
        },
        {
            icon: <Kanban className='w-4 h-4' />,
            label: (
                <div className='flex items-start justify-center gap-1'>
                    <p>Negócios</p>
                    {numBusiness > 0 && <p className='text-xs text-brand-400 font-bold'>{numBusiness}</p>}
                </div>
            ),
            value: 'tab3',
            content: <Business />
        },
        {
            icon: <FileCheck2 className='w-4 h-4' />,
            label: (
                <div className='flex items-start justify-center gap-1'>
                    <p>Documentos</p>
                    {numAttachments > 0 && <p className='text-xs text-brand-400 font-bold'>{numAttachments}</p>}
                </div>
            ),
            value: 'tab4',
            content: (
                <Card>
                    <h2 className='font-bold text-base mb-4'>Documentos da empresa</h2>
                    <p>Em desenvolvimento...</p>
                </Card>
            )
        }
    ]

    return <DefaultTabs tabs={tabsData} defaultValue='tab1' />
}
